import join from 'url-join';

import type { BuyItAgainGuestApiResponse, BuyItAgainGuestPlacement } from '@libs/common-types';
import { getLocale } from '@libs/core';

import { cweaClient } from '../clients/api-proxy-browser-client';
import { CWEA_ENDPOINTS } from '../constants';

export type GetBuyItAgainGuestInput = {
    placement?: BuyItAgainGuestPlacement;
    count?: number;
    inventoryList?: string;
    excludes?: string[];
};

export async function getBuyItAgainGuest(input: GetBuyItAgainGuestInput = {}): Promise<BuyItAgainGuestApiResponse> {
    const endpoint = CWEA_ENDPOINTS.buyItAgainGuest.getBuyItAgainGuestRecommendations;
    const searchParams = new URLSearchParams({
        locale: getLocale(),
        ...(input.placement && { placement: input.placement }),
        ...(input.count !== undefined && { count: String(input.count) }),
        ...(input.inventoryList && { inventoryList: input.inventoryList }),
        ...(input.excludes?.length && { excludes: input.excludes.join(',') }),
    });

    const result = await cweaClient.get<BuyItAgainGuestApiResponse>(join(endpoint, `?${searchParams.toString()}`), {
        useOldFetch: true,
    });

    if (!result) {
        throw new Error(`${endpoint} returned null`);
    }

    return result;
}
